import React, { createContext, useReducer, useEffect } from "react";
import { io } from "socket.io-client";

const initialState = {
  socket: null,
  currentUser: null,
  messages: [],
  onlineUsers: [],
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_SOCKET":
      return { ...state, socket: action.payload };
    case "SET_CURRENT_USER":
      return { ...state, currentUser: action.payload };
    case "NEW_MESSAGE":
      return { ...state, messages: [...state.messages, action.payload] };
    case "SET_ONLINE_USERS":
      return { ...state, onlineUsers: action.payload };
    default:
      return state;
  }
};

export const ChatContext = createContext();

const ChatContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const socket = io(process.env.REACT_APP_BACKEND_URL, {
      transports: ["websocket"],
    });
    dispatch({ type: "SET_SOCKET", payload: socket });

    socket.on("online-users", (users) => {
      dispatch({ type: "SET_ONLINE_USERS", payload: users });
    });

    socket.on("msg-receive", (message) => {
      dispatch({ type: "NEW_MESSAGE", payload: message });
    });

    return () => {
      socket.removeAllListeners();

      if (socket) {
        socket.disconnect();
      }
    };
  }, []);

  const sendMessage = (message) => {
    if (state.socket) {
      state.socket.emit("send-msg", message);
    }
  };

  const setCurrentUser = (userId) => {
    dispatch({ type: "SET_CURRENT_USER", payload: userId });
    if (state.socket) {
      state.socket.emit("add-user", userId);
    }
  };

  return (
    <ChatContext.Provider value={{ ...state, sendMessage, setCurrentUser }}>
      {children}
    </ChatContext.Provider>
  );
};

export default ChatContextProvider;
